import { t } from '@shared/helpers/translation';
import { IllustrationData } from '@ui/components/Illustration/Illustration.interfaces';
import {
    getBaggageInsuranceCompensation,
    getTravelInsuranceCompensation,
} from '@shared/config/market/market.helpers';
import { getMoneyObjectAsString } from '@shared/helpers/money';

export function getAddonIllustration(type: string): IllustrationData | undefined {
    switch (type) {
        case 'CancellationInsurance':
            return { type: 'CancellationInsurance3' };
        case 'LuggageInsurance':
            return { type: 'BaggageInsurance3' };
        case 'TravelInsurance':
            return { type: 'BaggageInsurance4' };
        default:
            return undefined;
    }
}

export function getAddonTitle(type: string): string {
    switch (type) {
        case 'CancellationInsurance':
            return t({ key: 'cancellation.cancellation_insurance' });
        case 'LuggageInsurance':
            return t({ key: 'shared.luggage_insurance' });
        case 'TravelInsurance':
            return t({ key: 'shared.travel_insurance' });
        default:
            return '';
    }
}

export function getAddonTexts(type: string): string[] {
    const travelCompensation = getTravelInsuranceCompensation();
    const baggageCompensation = getBaggageInsuranceCompensation();

    const getBaggageCompensationText = () =>
        baggageCompensation
            ? [
                  t({
                      key: 'shared.baggage_compensation',
                      values: [getMoneyObjectAsString(baggageCompensation)],
                  }),
              ]
            : [];

    const getTravelCompensationText = () =>
        travelCompensation
            ? [
                  t({
                      key: 'shared.travel_compensation',
                      values: [getMoneyObjectAsString(travelCompensation)],
                  }),
              ]
            : [];

    switch (type) {
        case 'CancellationInsurance':
            return [
                t({
                    key: 'cancellation.cancellation_insurance_usp_money_back',
                }),
                t({
                    key: 'cancellation.cancellation_insurance_usp_applies_to',
                }),
                t({
                    key: 'cancellation.cancellation_insurance_usp_quick_refund',
                }),
            ];
        case 'LuggageInsurance':
            return [
                t({
                    key: 'shared.theft_and_loss_baggage_compensation',
                }),
                ...getBaggageCompensationText(),
                t({ key: 'shared.no_deductible' }),
            ];
        case 'TravelInsurance':
            return [
                t({
                    key: 'shared.compensation_for_delays',
                }),
                ...getTravelCompensationText(),
                t({ key: 'shared.no_deductible' }),
            ];
        default:
            return [];
    }
}

export function getAddonWarningTexts(type: string): string[] {
    switch (type) {
        case 'CancellationInsurance':
            return [
                t({
                    key: 'cancellation.cancellation_insurance_post_booking',
                    suffix: '.',
                }),
                t({
                    key: 'cancellation.cancellation_insurance_money_back',
                    suffix: '.',
                }),
            ];
        case 'LuggageInsurance':
            return [
                t({ key: 'warning.luggage_insurance_help_theft' }),
                t({ key: 'warning.luggage_insurance_help_delay' }),
                t({ key: 'warning.luggage_insurance_help_during_trip' }),
                t({ key: 'warning.luggage_insurance_help_no_deductible' }),
            ];
        case 'TravelInsurance':
            return [
                t({
                    key: 'warning.travel_insurance_compensation_for_delays',
                }),
                t({ key: 'warning.travel_insurance_lost_vacation_reimbursement' }),
                t({
                    key: 'warning.travel_insurance_roadside_assistance_transport_baggage_delay',
                }),
            ];
        default:
            return [];
    }
}
